import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Shuffle, Sparkles, Check } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { logError } from "@/lib/log";

// One fresh coping skill a day, matched to recent check-ins
export const SkillOfDay = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/skill-of-the-day").then((r) => setD(r.data)).catch((e) => logError("Skill of the day failed:", e)); }, []);
  if (!d) return null;
  const s = d.skill;
  const swap = async () => {
    setBusy(true);
    try { const { data } = await api.post("/skill-of-the-day/swap"); setD(data); toast.success("Here's a different one 🌱"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="mm-card p-5 mt-6 mm-fade-up" data-testid="skill-of-day">
      <div className="flex items-start gap-4">
        <div className="w-14 h-14 shrink-0 rounded-2xl flex items-center justify-center text-3xl" style={{ background: `${s.color || "#7C5CBF"}22` }} aria-hidden>{s.icon || "🌱"}</div>
        <div className="min-w-0 flex-1">
          <div className="text-xs font-bold uppercase tracking-wider text-mm-primary">Skill of the day · {s.duration}</div>
          <h3 className="font-bold text-lg mt-0.5 break-words" data-testid="skill-of-day-name">{s.name}</h3>
          <p className="text-sm text-mm-muted mt-1">{s.description}</p>
          <p className="text-xs text-mm-muted mt-2 italic" data-testid="skill-of-day-reason">{d.reason}</p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2 mt-4">
        <Link to={`/coping?skill=${s.id}`} className="mm-btn !py-2 !px-4 text-sm" data-testid="skill-of-day-start">Start<ArrowRight size={15} /></Link>
        {d.tried && <span className="mm-chip !text-xs pointer-events-none" data-testid="skill-of-day-tried"><Check size={13} />Tried today</span>}
        {d.can_swap && !d.tried && <button onClick={swap} disabled={busy} className="mm-btn-ghost !py-2 !px-4 text-sm" data-testid="skill-of-day-swap"><Shuffle size={15} />Show me another</button>}
      </div>
      <StreakNote streak={d.streak} tried={d.tried} />
    </section>
  );
};

const StreakNote = ({ streak, tried }) => (
  <p className="flex items-center gap-1.5 text-xs text-mm-muted mt-3" data-testid="skill-of-day-streak">
    <Sparkles size={14} className="text-mm-primary shrink-0" />
    {streak > 0
      ? <span><b className="text-mm-text">{streak}-day skill streak</b>{tried ? " · your garden is glowing a little brighter" : " · try today's skill to keep it going"}</span>
      : <span>Try today's skill to start a gentle streak. Each day adds a sparkle to your garden.</span>}
  </p>
);
